import { createFileRoute } from "@tanstack/react-router";
import { PartnerPortal } from "@/pages/partner-portal/PartnerPortal";

export const Route = createFileRoute("/partner/")({
	component: PartnerPortal,
});
